export class Base64Helper {
  /**
   * Encodes a string to Base64 in a UTF-8 safe way.
   * This handles characters outside the Latin1 range (like 'º', 'á', etc.)
   */
  static encode(str: string): string {
    if (!str) return '';
    try {
      // First we escape the string using encodeURIComponent to get the UTF-8 encoding of the characters,
      // then we convert the percent encodings into raw bytes which can be fed into btoa.
      return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
        return String.fromCharCode(parseInt(p1, 16));
      }));
    } catch (e) {
      console.error('Error encoding to base64:', e);
      return btoa(str); // Fallback to standard btoa
    }
  }

  /**
   * Decodes a Base64 string in a UTF-8 safe way.
   */
  static decode(base64: string): string {
    if (!base64) return '';
    try {
      return decodeURIComponent(atob(base64).split('').map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    } catch (e) {
      console.error('Error decoding from base64:', e);
      return atob(base64); // Fallback to standard atob
    }
  }
}
